import { client } from '../client';
import { UserRoleName, UserProfile } from './types/UserProfile';

export const verifyInsuranceByAdmin = async ({
  user_id,
  payer_id,
  member_id,
  insured_by,
  group_number,
  userRole,
}: {
  user_id: string;
  payer_id: string;
  member_id: string;
  insured_by: string;
  group_number?: string;
  userRole?: string;
}): Promise<UserProfile> => {
  const prefix =
    userRole === UserRoleName.CareAdvisor
      ? 'care_advisor'
      : userRole === UserRoleName.Collector
      ? 'collector'
      : 'admin';
  const { data } = await client.post(`/${prefix}/users/${user_id}/verify_insurance`, {
    payer_id,
    member_id,
    insured_by,
    group_number,
  });
  return data;
};
